import { createSlice } from '@reduxjs/toolkit';
import { IpafResultReducer } from '../../reducers/IpafHashesReducer';

const initialState: any = {
	preIpafIsUpdated: false,
	hashesStateForms: [],
};

export const publicIpafSlice = createSlice({
	name: 'public-ipaf-hashes',
	initialState,
	reducers: IpafResultReducer,
});

export const { setHashes, setPublicPreIpafIsUpdated, updatePublicFormHash } =
	publicIpafSlice.actions;

export default publicIpafSlice.reducer;
